import {combineReducers} from 'redux';
import EditPWChallengeReducer
  from './edit_pw_challenge_reducer/EditPWChallengeReducer';

export default combineReducers({
  editPWChallenge: EditPWChallengeReducer,
});
